import { render } from "./VerificationQes.vue?vue&type=template&id=616a3e1c"
import script from "./VerificationQes.vue?vue&type=script&lang=js"
export * from "./VerificationQes.vue?vue&type=script&lang=js"
script.render = render

export default script